/* @flow */
import * as React from 'react';

import AdminUpgradeHelpForm, { SOURCES } from 'admin/components/AdminUpgradeHelpForm';
import AdminUpgradeTitle from 'admin/components/AdminUpgradeTitle';
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import EventTracking from 'lib/EventTracking';
import Row from 'components/Row';

type Props = {
  onRequestHide?: Function,
  onDone?: Function,
  quoteUuid?: ?string,
  organizationUuid?: ?string,
  source: SOURCES,
  utmParams?: UTMParams,
};

class AdminUpgradeHelpModal extends React.Component<Props> {
  static trackingPrefix = 'admin_self_serve.help_modal';

  componentDidMount() {
    this.track('view');
  }

  track = (key: string) => {
    EventTracking.trackKey(`${AdminUpgradeHelpModal.trackingPrefix}.${key}`);
  };

  handleDone = () => {
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }

    // callback from parent
    if (this.props.onDone) {
      this.props.onDone();
    }
  };

  handleClose = () => {
    this.track('close.click');
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  };

  render() {
    return (
      <Dialog size="medium" onRequestHide={this.handleClose}>
        <BoxBody>
          <Row>
            <AdminUpgradeTitle
              title="Questions about purchasing Remind Hub?"
              subtext="Our team is always happy to chat!"
            />
          </Row>
          <AdminUpgradeHelpForm
            source={this.props.source}
            onDone={this.handleDone}
            quoteUuid={this.props.quoteUuid}
            organizationUuid={this.props.organizationUuid}
            utmParams={this.props.utmParams}
          />
        </BoxBody>
      </Dialog>
    );
  }
}

export default AdminUpgradeHelpModal;
